export const contractVerificationHints = {
  required: 'Field is required',
}
